module.exports = __webpack_public_path__ + "media/svg/gf-95747314.svg";